
import { useState } from 'react';
import Button from '../../../components/base/Button';
import BookingCalendar from '../../../components/feature/BookingCalendar';

export default function PricingSection() {
  const [isBookingOpen, setIsBookingOpen] = useState(false);

  const openBookingCalendar = () => {
    setIsBookingOpen(true);
  };

  const navigateToPolizza = () => {
    window.REACT_APP_NAVIGATE('/polizza-morosita');
  };

  return (
    <>
      <section id="prezzi" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Prezzi Trasparenti
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Scegli il pacchetto più adatto alle tue esigenze. 
              Tutti i prezzi sono fissi e senza sorprese.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
            {/* Consulenza Iniziale Gratuita */}
            <div className="bg-gray-50 rounded-xl p-6 relative">
              <div className="text-center mb-6">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-video-chat-line text-2xl text-green-600"></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">Consulenza Iniziale</h3>
                <div className="text-3xl font-bold text-gray-900 mb-2">
                  Gratuito
                </div>
                <p className="text-sm text-gray-500">15 minuti</p>
              </div>
              
              <ul className="space-y-2 mb-6 text-sm">
                <li className="flex items-start">
                  <i className="ri-check-line text-green-600 mr-2 mt-0.5"></i>
                  <span className="text-gray-700">Videoconferenza 15 min</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-green-600 mr-2 mt-0.5"></i>
                  <span className="text-gray-700">Analisi situazione</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-green-600 mr-2 mt-0.5"></i>
                  <span className="text-gray-700">Contratto più indicato</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-green-600 mr-2 mt-0.5"></i>
                  <span className="text-gray-700">Consulenza base</span>
                </li>
              </ul>
              
              <Button 
                variant="outline" 
                size="sm" 
                className="w-full cursor-pointer"
                onClick={openBookingCalendar}
              >
                Prenota Gratis
              </Button>
            </div>

            {/* Redazione Contratto */}
            <div className="bg-blue-50 rounded-xl p-6 relative">
              <div className="text-center mb-6">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-file-text-line text-2xl text-blue-600"></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">Redazione Contratto</h3>
                <div className="text-3xl font-bold text-blue-600 mb-2">
                  €75
                </div>
                <p className="text-sm text-gray-500">Contratto personalizzato</p>
              </div>
              
              <ul className="space-y-2 mb-6 text-sm">
                <li className="flex items-start">
                  <i className="ri-check-line text-green-600 mr-2 mt-0.5"></i>
                  <span className="text-gray-700">Videoconferenza interattiva</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-green-600 mr-2 mt-0.5"></i>
                  <span className="text-gray-700">Preparazione in diretta</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-green-600 mr-2 mt-0.5"></i>
                  <span className="text-gray-700">Agente specializzato</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-green-600 mr-2 mt-0.5"></i>
                  <span className="text-gray-700">Pagamento a fine servizio</span>
                </li>
              </ul>
              
              <Button 
                size="sm" 
                className="w-full cursor-pointer"
                onClick={openBookingCalendar}
              >
                Richiedi Contratto
              </Button>
            </div>

            {/* Polizza Assicurativa Morosità */}
            <div className="bg-red-50 rounded-xl p-6 relative border-2" style={{ borderColor: '#fff2f200' }}>
              <div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
                <span className="bg-red-500 text-white px-3 py-1 rounded-full text-xs font-semibold whitespace-nowrap">
                  Protezione Totale
                </span>
              </div>
              <div className="text-center mb-6">
                <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-shield-star-line text-2xl text-red-600"></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">Polizza Morosità</h3>
                <div className="text-3xl font-bold text-red-600 mb-2">
                  Gratuito
                </div>
                <p className="text-sm text-gray-500">Parere di fattibilità</p>
              </div>
              
              <ul className="space-y-2 mb-6 text-sm">
                <li className="flex items-start">
                  <i className="ri-check-line text-green-600 mr-2 mt-0.5"></i>
                  <span className="text-gray-700">Valutazione gratuita</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-green-600 mr-2 mt-0.5"></i>
                  <span className="text-gray-700">Fino a 12 mesi affitto</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-green-600 mr-2 mt-0.5"></i>
                  <span className="text-gray-700">Copertura danni</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-green-600 mr-2 mt-0.5"></i>
                  <span className="text-gray-700">Spese legali incluse</span>
                </li>
              </ul>
              
              <Button 
                variant="outline"
                size="sm" 
                className="w-full cursor-pointer"
                onClick={navigateToPolizza}
              >
                Scopri di Più
              </Button>
            </div>

            {/* Firma a Distanza */}
            <div className="bg-orange-50 rounded-xl p-6 relative">
              <div className="text-center mb-6">
                <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-quill-pen-line text-2xl text-orange-600"></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">Firma a Distanza</h3>
                <div className="text-3xl font-bold text-orange-600 mb-2">
                  €60
                </div>
                <p className="text-sm text-gray-500">Pieno valore legale !</p>
              </div>
              
              <ul className="space-y-2 mb-6 text-sm">
                <li className="flex items-start">
                  <i className="ri-check-line text-green-600 mr-2 mt-0.5"></i>
                  <span className="text-gray-700">Firma digitale sicura</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-green-600 mr-2 mt-0.5"></i>
                  <span className="text-gray-700">Pieno valore legale</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-green-600 mr-2 mt-0.5"></i>
                  <span className="text-gray-700">Processo online</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-green-600 mr-2 mt-0.5"></i>
                  <span className="text-gray-700">Assistenza dedicata</span>
                </li>
              </ul>
              
              <Button 
                size="sm" 
                className="w-full cursor-pointer"
                onClick={openBookingCalendar}
              >
                Richiedi Firma
              </Button>
            </div>

            {/* Registrazione AdE */}
            <div className="bg-purple-50 rounded-xl p-6 relative">
              <div className="text-center mb-6">
                <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-government-line text-2xl text-purple-600"></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">Registrazione Agenzia Entrate</h3>
                <div className="text-3xl font-bold text-purple-600 mb-2">
                  €40
                </div>
                <p className="text-sm text-gray-500">Escluse tasse</p>
              </div>
              
              <ul className="space-y-2 mb-6 text-sm">
                <li className="flex items-start">
                  <i className="ri-check-line text-green-600 mr-2 mt-0.5"></i>
                  <span className="text-gray-700">Registrazione ufficiale</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-green-600 mr-2 mt-0.5"></i>
                  <span className="text-gray-700">Pratiche burocratiche</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-green-600 mr-2 mt-0.5"></i>
                  <span className="text-gray-700">Conformità normativa</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-green-600 mr-2 mt-0.5"></i>
                  <span className="text-gray-700">Tasse escluse dal prezzo</span>
                </li>
              </ul>
              
              <Button 
                variant="outline"
                size="sm" 
                className="w-full cursor-pointer"
                onClick={openBookingCalendar}
              >
                Richiedi Registrazione
              </Button>
            </div>
          </div>

          <div className="mt-16 text-center">
            <div className="bg-blue-50 rounded-xl p-8 max-w-4xl mx-auto">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                <i className="ri-question-line text-blue-600 mr-2"></i>
                Hai Dubbi sulla Scelta?
              </h3>
              <p className="text-gray-600 mb-6">
                Prenota la tua consulenza gratuita di 15 minuti e ti aiuteremo a scegliere 
                il pacchetto più adatto alle tue esigenze specifiche.
              </p>
              <Button 
                size="lg"
                onClick={openBookingCalendar}
              >
                <i className="ri-calendar-fill mr-2"></i>
                Prenota Consulenza Gratuita
              </Button>
            </div>
          </div>
        </div>
      </section>

      <BookingCalendar 
        isOpen={isBookingOpen} 
        onClose={() => setIsBookingOpen(false)} 
      />
    </>
  );
}
